import {PKOM_TYPE_IMAGE} from '../constants';
import {SearchAssetInformationDto} from '../models';

/**
 * Prüft ob ein Asset vom Typ 'Bild' (PKOM_TYPE_IMAGE) ist.
 *
 * @param asset Das zu prüfende Asset
 * @returns true wenn das Asset ein Bild ist
 */
export const isImage = (asset: SearchAssetInformationDto): boolean => {
  return asset.pkomType === PKOM_TYPE_IMAGE;
};
